////////////////////
// Template
////////////////////
const template = /*html*/ `
    <div class="c-form_item">
        <label class="c-form_label" v-if="hasLabel">{{label}}</label>

        <div class="c-form_select">
            <select class="c-form_select_input" v-model="selectedValue" @change="onSelect">
                <option value="" disabled>{{ label }}</option>
                <option :value="value" v-for="(value, index) in values" :key="index">{{ value | capitalize }}</option>
            </select>
        </div>
    </div>
`;


////////////////////
// Scripts
////////////////////
export default function VueProductFormSelector() {

    Vue.component("product-form-selector", {

        template,

        props: {
            label: {
                type: String,
                required: true
            },
            hasLabel: {
                type: Boolean,
                required: false
            },
            values: {
                type: Array,
                default: () => []
            },
            currentValue: {
                type: String,
                required: true
            },
            position: {
                type: Number,
                required: true
            }
        },

        data() {
            return {
                selectedValue: ''
            };
        },

        created() {

        },

        mounted() {
            this.selectedValue = this.currentValue
        },

        methods: {
            /////////////////
            // Callbacks
            /////////////////
            onSelect() {
                this.$emit('onSelect', {
                    position: this.position,
                    value: this.selectedValue
                })
            }
        }
    });
}
